module.exports = __webpack_public_path__ + "static/media/bd-panelists.2854b80d.png";